import { tableEnUSTranslations } from "../components/table/_lang/en-US";
import { draftEnUSTranslations } from "../hooks/_lang/en-US";

export const rayaLucariaEnUS = {
  ...tableEnUSTranslations,
  ...draftEnUSTranslations,
  apply: "Apply",
  cancel: "Cancel",
  close: "Close",
  clear: "Clear",
  confirm: "Confirm",
  filter: "Filter",
  filterValue: "Filter value",
  expandMenu: "Expand menu",
  collapseMenu: "Collapse menu",
  openMenu: "Open menu",
  mainNavigation: "Main navigation",
  secondaryNavigation: "Secondary navigation",
  navigationMenu: "Navigation menu",
};

export type RayaLucariaTranslationKey = keyof typeof rayaLucariaEnUS;
